import axios from "axios";

export default axios.create({
    baseURL: 'https://modena.monte360.com/investor/getInvestments.php',
    headers: {
        "Content-Type": "application/json",
} 
});
